import { BaseAction } from '../../store/actions';
import { BulkUploadTaskContainer, BulkUploadTaskUpdate, JobsUploadError, JobsUploadStatus } from '../../shared/models/jobs';

export enum UploadActions {
  UploadRequest = '[Jobs Upload] Start Upload',
  UploadSuccess = '[Jobs Upload] Upload Success',
  UploadError = '[Jobs Upload] Upload Error',

  ProcessUpload = '[Jobs Upload] Start Processing',
  ProcessUploadSuccess = '[Jobs Upload] Processing Success',
  ProcessUploadError = '[Jobs Upload] Processing Error',

  LoadUploads = '[Jobs Upload] Load Uploads',
  LoadUploadsSuccess = '[Jobs Upload] Load Uploads Success',
  LoadUploadsError = '[Jobs Upload] Load Uploads Error',

  LoadRowsRequest = '[Jobs Upload] Load Rows',
  LoadRowsSuccess = '[Jobs Upload] Load Rows Success',
  LoadRowsError = '[Jobs Upload] Load Rows Error',

  UpdateRow = '[Jobs Upload] Update Row',
  UpdateRowSuccess = '[Jobs Upload] Update Row Success',
  UpdateRowError = '[Jobs Upload] Update Row Error',

  ClearRows = '[Jobs Upload] Clear Rows',

  ExportRecords = '[Jobs Upload] Export Records',
  ExportRecordsSuccess = '[Jobs Upload] Export Records Success',
  ExportRecordsError = '[Jobs Upload] Export Records Error',
}

export class UploadJobsRequest implements BaseAction<UploadActions> {
  readonly type = UploadActions.UploadRequest;

  constructor(public readonly file: File, public readonly uploadID?: string) {}
}

export class UploadJobsSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.UploadSuccess;

  constructor(public readonly payload: JobsUploadStatus) {}
}

export class UploadJobsError implements BaseAction<UploadActions> {
  readonly type = UploadActions.UploadError;

  constructor(public readonly payload: JobsUploadError) {}
}

export class ProcessUpload implements BaseAction<UploadActions> {
  readonly type = UploadActions.ProcessUpload;

  constructor(public readonly uploadID: string) {}
}

export class ProcessUploadSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.ProcessUploadSuccess;

  constructor(public readonly payload: JobsUploadStatus) {}
}

export class ProcessUploadError implements BaseAction<UploadActions> {
  readonly type = UploadActions.ProcessUploadError;

  constructor(public readonly payload: string) {}
}

export class LoadUploads implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadUploads;
}

export class LoadUploadsSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadUploadsSuccess;

  constructor(public readonly payload: JobsUploadStatus[]) {}
}

export class LoadUploadsError implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadUploadsError;

  constructor(public readonly payload: string) {}
}

export class LoadRows implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadRowsRequest;

  constructor(public readonly uploadID: string) {}
}

export class LoadRowsSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadRowsSuccess;

  constructor(public readonly rows: BulkUploadTaskContainer[]) {}
}

export class LoadRowsError implements BaseAction<UploadActions> {
  readonly type = UploadActions.LoadRowsError;

  constructor(public readonly payload: string) {}
}

export class UpdateRow implements BaseAction<UploadActions> {
  readonly type = UploadActions.UpdateRow;

  constructor(
    public readonly uploadID: string,
    public readonly taskID: string,
    public readonly payload: BulkUploadTaskUpdate,
  ) {}
}

export class UpdateRowSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.UpdateRowSuccess;

  constructor(public readonly task: BulkUploadTaskContainer) {}
}

export class UpdateRowError implements BaseAction<UploadActions> {
  readonly type = UploadActions.UpdateRowError;

  constructor(public readonly payload: string) {}
}

export class ClearRows implements BaseAction<UploadActions> {
  readonly type = UploadActions.ClearRows;
}

export class ExportRecords implements BaseAction<UploadActions> {
  readonly type = UploadActions.ExportRecords;

  constructor(public readonly ids: number[]) {}
}

export class ExportRecordsSuccess implements BaseAction<UploadActions> {
  readonly type = UploadActions.ExportRecordsSuccess;
}

export class ExportRecordsError implements BaseAction<UploadActions> {
  readonly type = UploadActions.ExportRecordsError;

  constructor(public readonly payload: string) {}
}

export type UploadAction = UploadJobsRequest | UploadJobsSuccess | UploadJobsError |
  ProcessUpload | ProcessUploadSuccess | ProcessUploadError |
  LoadUploads | LoadUploadsSuccess | LoadUploadsError |
  LoadRows | LoadRowsSuccess | LoadRowsError |
  UpdateRow | UpdateRowSuccess | UpdateRowError |
  ClearRows |
  ExportRecords | ExportRecordsSuccess | ExportRecordsError;